import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AppService } from '../../shared/services/app.service'
import { TranslateService } from '@ngx-translate/core';

import { LanguageService } from '../../shared/services/language.service';


import { AccountService } from '../../shared/services/account.service';
import { LocalstorageService } from '../../shared/services/localstorage.service'

import { ResellerService } from '../../shared/services/reseller.service';
import { RegisterSettingService } from '../../shared/services/register-setting.service'

import { getNames } from '../../shared/thirdparty/countries/countries'


declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any
declare var grecaptcha:any;



@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit {

	public user: any = {
		"reseller" : "0",
		"country" : "",
		"companyGroup":null,
		"newsletter": true,
		"gotFreeTrialAsked":false,
		"activity" : "0",
		"known" : "0",
		"knownOther" : null,
		"companyFunction" : "0",
	};
	public feedback: any = {};

	public resellers = []

	public registerMethod = null

	public byreseller:any = {
		"countryId" : "",
		"countryText" : "",
		"resellerId" : "",
		"resellerName" : ""
	}

	public captchaDisplay = true;

	public legalChecked = false;

	public activitys = [];
	public knowns = [];

	public allCountries = []

	public functions:any = [
		{id :'Achat', name : 'Achat'},
		{id :'Finance / Juridique', name : 'Finance / Juridique'},
		{id :'Formation', name : 'Formation'},
		{id :'HSE', name : 'HSE'},
		{id :'Informatique', name : 'Informatique'},
		{id :'Innovation', name : 'Innovation'},
		{id :'Marketing / Com', name : 'Marketing / Com'},
		{id :'Production', name : 'Production'},
		{id :'RH', name : 'RH'},
	]

	public showGratitude = false

	public validPassword = false

	public showPassword = [false, false]

  public trimmedEmail = ""

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public accountService: AccountService,
		public appService: AppService,
		public translate: TranslateService,
		public language : LanguageService,
		public resellerService : ResellerService,
		public registerSettingService : RegisterSettingService,
		public localStorage : LocalstorageService
	) {

	}

	ngOnInit() {

		if(this.localStorage && this.localStorage.getItem('preFillEmail') && this.localStorage.getItem('preFillEmail') != 'undefined'){
			this.user['mail'] = this.localStorage.getItem('preFillEmail')

		}
		this.localStorage.removeItem('preFillEmail')


		this.activatedRoute.params.subscribe((params: Params) => {
			this.user.preferredLanguage = "en";
			if(params["param"]){
				try{
					var urlDatas = JSON.parse(atob(params["param"]))
					if(urlDatas['method']){
						if(urlDatas["method"] == "meeting"){
							this.refreshResellers()
							if(urlDatas["key"]){
								this.accountService.getTmpAccountByToken(urlDatas["key"])
								.then((res)=>{
									if(res){
										this.user = res;
										this.user["reseller"] = "0"
										this.registerMethod = "meeting"
									}
								})
							}
						}
						else if(urlDatas["method"] == "addtorepertoire"){
							this.refreshResellers()
							this.registerMethod = "addtorepertoire"
						}
						else if(urlDatas["method"] == "bygroup"){
							this.user.companyGroup = urlDatas["groupId"];
						}
					}
					else{
						this.refreshResellers()
					}
				}
				catch(err){
				}
			}
			if(params && params["freetrial"]){
				if(isBrowser()) $("#gotFreeTrialChk").attr("checked",true)
				this.user["gotFreeTrialAsked"]=true;
			}
		});
		var allCountriesOBJ = getNames(this.translate.store.currentLang)
        this.allCountries = []
        for(let ctr of Object.keys(allCountriesOBJ)){
            this.allCountries.push({code : ctr.toLowerCase(), name : allCountriesOBJ[ctr]})
        }
		this.filterRegisterSetting();
	}

	ngAfterViewInit(){
		$('.register-lock').tooltip()
	}

	register() {
		this.feedback = {}
		let valid = true;

		if (this.user["name"] && (this.user["name"].length > 4 || this.user["name"].length < 20)) {
			this.feedback["message1"] = 0;
		} else {
			this.feedback["message1"] = this.language.translate.instant("Veuillez entrer un nom de compte valide (entre 4 et 20 caractères)");

			valid = false;
		}

		if (this.user["company"] && (this.user["company"].length > 4 || this.user["company"].length < 100)) {
			this.feedback["message5"] = 0;
		} else {
			this.feedback["message5"] = this.language.translate.instant("Veuillez entrer un nom d'entreprise valide (entre 4 et 100 caractères)");

			valid = false;
		}

		if(this.user["activity"] != 0) {
			this.feedback["message10"] = 0;
		} else {
			this.feedback["message10"] = this.language.translate.instant("Veuillez sélectionner un secteur d'activité valide ");

			valid = false;
		}

		if(this.user["companyFunction"] != 0) {
			this.feedback["message17"] = 0;
		} else {
			this.feedback["message17"] = this.language.translate.instant("Veuillez sélectionner une fonction ");

			valid = false;
		}

		if (this.user["password"] !== this.user["password2"]) {
			this.feedback["message21"] = this.language.translate.instant("Les mots de passe ne correspondent pas");

			valid = false;
		} else if (!this.validPassword) {

			valid = false;
		} else {
			this.feedback["message2"] = 0;
		}

		let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		if(regex.test(this.user["mail"])) {
			this.feedback["message3"] = 0;
		} else {
			this.feedback["message3"] = this.language.translate.instant("L'adresse mail n'est pas valide");

			valid = false;
		}
		if(this.user["phone"] != null && this.user["phone"].length) {
			this.feedback["message4"] = 0;
		} else {
			this.feedback["message4"] = this.language.translate.instant("Le numéro de téléphone n'est pas valide");

			valid = false;
		}

		if(this.user["country"]) {
			this.feedback["message6"] = 0;
		} else {
			this.feedback["message6"] = this.language.translate.instant("Le pays est requis");

			valid = false;
		}

		if(this.user["known"] != 0) {
			this.feedback["message11"] = 0;
		} else {
			this.feedback["message11"] = this.language.translate.instant("Le lieu est requis");

			valid = false;
		}

		if(this.legalChecked){
			this.feedback["message7"] = 0;
		} else {
			this.feedback["message7"] = this.language.translate.instant("Vous devez accepter les conditions générales de vente");

			valid = false;
		}

		if (valid) {

			Swal.showLoading();

			this.user.captcha=grecaptcha.getResponse()

			this.user['name'] = this.user['name'].trim()
			this.user['company'] = this.user['company'].trim()

			this.accountService.register(this.user).then(res => {
				this.feedback = res;
				if (res["status"] == "error") {

					if(res['message'] == 'bad_captcha'){
						Swal.fire(this.language.translate.instant('Erreur'),this.language.translate.instant("Veuillez re-valider le captcha"), 'error');
						this.feedback["danger"] = this.language.translate.instant("Veuillez re-valider le captcha");
						this.feedback["success"] = 0;
					}
					else if(res['message'] == 'Account already exist with this mail'){
						Swal.fire(this.language.translate.instant('Erreur'),this.language.translate.instant("Il semblerait qu'un compte avec le même nom et/ou adresse mail existe déjà !"), 'error');
						this.feedback["danger"] = this.language.translate.instant("Il semblerait qu'un compte avec le même nom et/ou adresse mail existe déjà !");
						this.feedback["success"] = 0;
					}
					else{
						Swal.fire(this.language.translate.instant('Erreur'),this.language.translate.instant("Une erreur est survenue, veuillez réessayer plus tard"), 'error');
						this.feedback["danger"] = 0;
						this.feedback["success"] = 0;
					}

					grecaptcha.reset()
				}
				else{
					this.showGratitude = true
					Swal.fire({
						'text' : this.language.translate.instant('Votre compte a bien été créé! Vous avez reçu un email de confirmation. Consultez cet email et cliquez sur le lien d\'activation'),
						'icon' : 'success',
						'showCancelButton': false,
						'timer' : 5000
					})
					.then(()=>{
						Swal.close();
						this.router.navigate(this.language.navigateAccordingToLang(['/']));
					})
					grecaptcha.reset()
				}
			});
		} else {
			grecaptcha.reset()
			Swal.fire(this.language.translate.instant('Erreur'),this.language.translate.instant("Le formulaire d'inscription contient une erreur!"), 'error')
			this.feedback["danger"] = this.language.translate.instant("Le formulaire d'inscription contient une erreur!");
		}
	}

	refreshResellers(){
		return new Promise((resolve)=>{
			if(!this.user['country']){ this.user['country'] = "us" }
			this.resellerService.refreshResellers(this.user['country'])
			.then((res)=>{
				this.resellers = res
				resolve(undefined)
			})

		})

	}

	filterRegisterSetting(){
		this.activitys = [];
		this.knowns = [];
		return this.registerSettingService.getAllRegisterSetting()
		.then((res)=>{
			this.activitys = res.filter(e => e.type == "activity")
			this.knowns = res.filter(e => e.type == "known")
			console.log(this.activitys)
		})
	}

    iframeLoaded(){
        this.showGratitude = false;
    }

  removeSpace(x){
    if (x.isComposing || x.keyCode === 32) {
      this.user.mail = x.target.value.replace(/ /g,'')
    }
  }

}
